import React, { useState } from "react";
import Layout from "../../../layout/Layout";
import { read, utils, writeFile } from "xlsx";
import {
  Button,
  Grid,
  Snackbar,
  Typography,
  Alert as MuiAlert,
} from "@mui/material";
import { agentUserAPI, config, userData } from "../../../config";
import axios from "axios";

function User() {
  const [lstUser, setUser] = useState([]);
  const [messageType, setMessageType] = React.useState("success");
  const [message, setMessage] = React.useState("");
  const [open, setOpen] = React.useState(false);

  const handleImport = ($event) => {
    const files = $event.target.files;
    if (files.length) {
      const file = files[0];
      const reader = new FileReader();
      reader.onload = (event) => {
        const wb = read(event.target.result);
        const sheets = wb.SheetNames;

        if (sheets.length) {
          const rows = utils.sheet_to_json(wb.Sheets[sheets[0]]);
          setUser(rows);
          console.log(rows);
        }
      };
      reader.readAsArrayBuffer(file);
    }
  };

  const fetchImportDataResponse = () => {
    var reqData = JSON.stringify({
      lstUser: lstUser,
      intSPType: 2,
    });

    config.method = "patch";
    config.url = agentUserAPI;
    config.data = reqData;

    axios(config)
      .then(function (response) {
        setUser(response.data.data);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      });
  };

  const handleSubmit = () => {
    var reqData = JSON.stringify({
      lstUser: lstUser,
      intAgentID: userData.id,
      intSPType: 1,
    });

    config.method = "patch";
    config.url = agentUserAPI;
    config.data = reqData;

    axios(config)
      .then(function (response) {
        // setUser(response.data);
        fetchImportDataResponse();
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      });
  };

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  return (
    <Layout>
      <Snackbar open={open} autoHideDuration={5000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity={messageType}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} lg={6}>
          <input
            type="file"
            name="file"
            className="custom-file-input"
            id="inputGroupFile"
            required
            onChange={handleImport}
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </Grid>

        <Grid item xs={12} md={6} lg={6}>
          <Button className={"btn-primary"} onClick={handleSubmit}>
            Submit
          </Button>
        </Grid>

        <Grid item xs={12} md={12} lg={12}>
          <table>
            <thead>
              <th>
                <Typography>S.No</Typography>
              </th>
              <th>
                <Typography>Name</Typography>
              </th>
              <th>
                <Typography>Emp No</Typography>
              </th>
              <th>
                <Typography>Username</Typography>
              </th>
              <th>
                <Typography>Password</Typography>
              </th>
              <th>
                <Typography>Phone</Typography>
              </th>
              <th>
                <Typography>Email</Typography>
              </th>
              <th>
                <Typography>Title</Typography>
              </th>
              <th>
                <Typography>Department</Typography>
              </th>
              <th>
                <Typography>Branch</Typography>
              </th>
              <th>
                <Typography>Location Group</Typography>
              </th>
              <th>
                <Typography>State</Typography>
              </th>
              <th>
                <Typography>Status</Typography>
              </th>
            </thead>
            <tbody>
              {lstUser.map((row, index) => (
                <tr key={index}>
                  <td>
                    <Typography>{index + 1}</Typography>
                  </td>
                  <td>
                    <Typography>{row.name}</Typography>
                  </td>
                  <td>
                    <Typography>{row.emp_no}</Typography>
                  </td>
                  <td>
                    <Typography>{row.username}</Typography>
                  </td>
                  <td>
                    <Typography>{row.password}</Typography>
                  </td>
                  <td>
                    <Typography>{row.phone}</Typography>
                  </td>
                  <td>
                    <Typography>{row.email}</Typography>
                  </td>
                  <td>
                    <Typography>{row.title}</Typography>
                  </td>
                  <td>
                    <Typography>{row.department}</Typography>
                  </td>
                  <td>
                    <Typography>{row.branch}</Typography>
                  </td>
                  <td>
                    <Typography>{row.location_group}</Typography>
                  </td>
                  <td>
                    <Typography>{row.state}</Typography>
                  </td>
                  <td>
                    <Typography>{row.return_message}</Typography>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Grid>
      </Grid>
    </Layout>
  );
}

export default User;
